import { render, staticRenderFns } from "./DocumentTemplates.vue?vue&type=template&id=c36b922c&scoped=true&"
import script from "./DocumentTemplates.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplates.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTemplates.vue?vue&type=style&index=0&id=c36b922c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36b922c",
  null
  
)

export default component.exports